<template lang="pug">
div(v-if='list')
    .modal-exportar-shape
        b Selecione as camadas que deseja exportar
        .itens-checkbox
        checkbox-input-component(v-model='checkTodos', :mostrar-nome='true') 
        checkbox-group-input-component(v-model='areasSelecionadas', :list='list')
        el-divider
    .rodape
        button-component(label='Baixar Shape', icon='mdi-check', @click.native='exportarShape')
</template>

<script>
import { exportarAreasRecomporByCodigoImovel } from '@/services/processo.service';

export default {

    props: {
        codigoImovel: String,
    },

    data() {
        return {
            checkTodos: { id: 0, nome: 'Todos', selecionado: false, codigo: 'TODOS' },
            areasSelecionadas: [],
            list: [
                { id: 1, nome: 'Área do Imóvel', selecionado: false, codigo: 'IMOVEL' },
                { id: 3, nome: 'Área de Preservação Permanente a recompor', selecionado: false, codigo: 'AREA_PRESERVACAO_PERMANENTE' },
                { id: 2, nome: 'Área de Reserva Legal a recompor', selecionado: false, codigo: 'RESERVA_LEGAL' },
                { id: 2, nome: 'Área de Uso Restrito a recompor', selecionado: false, codigo: 'USO_RESTRITO' },
            ],
        };
    },

    watch: {
        "checkTodos.selecionado"(novoValor) {
            this.list.forEach(item => {
                item.selecionado = novoValor;
            });
        },
    },

    methods: {
        async exportarShape() {
            const listaCodigos = this.list.filter(item => item.selecionado).map(item => item.codigo);
            if (listaCodigos.length === 0) {
                this.$notify({
                    title: 'Atenção ',
                    message: 'É necessário selecionar as camadas que deseja exportar.',
                    type: 'warning',
                });
                return;
            }

            try {
                const blob = await exportarAreasRecomporByCodigoImovel(this.codigoImovel, listaCodigos);

                if (blob.size === 0) {
                    this.$notify({
                        title: 'Atenção!',
                        message: 'Não foram encontradas áreas a recompor correspondentes às opções selecionadas para este imóvel.',
                        type: 'warning',
                    });
                    return;
                }
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.codigoImovel + '.zip'); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                this.$notify({
                    title: 'Erro',
                    message: 'Não foi possível exportar o arquivo.',
                    type: 'error',
                });
            } finally {
                this.$emit('close');
                this.areasSelecionadas = [];
            }
        },

    },
};
</script>

<style>
.modal-exportar-shape {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content:flex-start;
    padding-top: 20px;
}

.checkbox-option {
    justify-content: flex-start !important;
}

.itens-checkbox {
    margin-top: 20px;
}

.rodape {
    display: flex;
    justify-content: flex-end;
}
</style>
